<select class="block w-full h-10 px-3 py-2 text-base font-normal bg-white border rounded-s rounded-e placeholder-slate-400 focus:outline-none" [(ngModel)]="id" [ngModelOptions]="{standalone: true}" (change)="changeEventEmitter.emit(id)">
    @for (item of values; track $index) {
        <option [value]="item" [selected]="id === item">{{ translateValue ? literalService.get(item, true) : value }}</option>
    }
</select>